import React, { useEffect, useRef } from "react";

import { gaClickBanner, gaShownBanner } from "../../libs/ga";
import { clickBanner } from "../../libs/banner";

import { BannerItem, LinkLocationType } from "../../services/bannerServices";

type Props = {
  item: BannerItem;
  position: LinkLocationType;
  className?: string;
  imageClassName?: string;
};

export default function DefaultBanner({
  item,
  position,
  className = "rounded-2xl mb-2",
  imageClassName = "",
}: Props) {
  const bannerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const currentBannerRef = bannerRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gaShownBanner(position, item);
          }
        });
      },
      { threshold: 1.0 }
    );

    if (currentBannerRef) {
      observer.observe(currentBannerRef);
    }

    return () => {
      if (currentBannerRef) {
        observer.unobserve(currentBannerRef);
      }
    };
  }, [item, position]);

  return (
    <div
      ref={bannerRef}
      className={className}
      onClick={() => {
        gaClickBanner(position, item);
        clickBanner(item);
      }}
    >
      <img
        src={item.file}
        alt={`banner-${item.file}`}
        className={imageClassName}
      />
    </div>
  );
}
